import * as React from 'react';
import { withRouter } from 'react-router-dom';

import classNames from 'classnames';

import { getConfig } from '@constants';

import { Link } from '../Link';

import { IBreadcrumb, IBreadcrumbsProps } from './types';

import * as s from './Breadcrumbs.scss';

export const BreadcrumbsView: React.FC<IBreadcrumbsProps> = (props: IBreadcrumbsProps ) => {
	const {
		className,
		breadcrumbs,
	} = props;

	if (getConfig().isTwa) {
		return null;
	}

	return (
		<div className={classNames(s.block, className)}>
			{
				breadcrumbs.map((breadcrumb: IBreadcrumb) =>
					(
						<Link
							className={s.item}
							key={breadcrumb.title + breadcrumb.link}
							to={breadcrumb.link || null}
						>
							<span className={s.title}>{breadcrumb.title}</span>
						</Link>
					),
				)
			}
		</div>
	);
};

export const Breadcrumbs = withRouter(BreadcrumbsView);
